import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Dashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [stats, setStats] = useState(null);
  const [letzte, setLetzte] = useState([]);

  useEffect(() => {
    api.get('/stats').then(r => setStats(r.data)).catch(() => {});
    api.get('/bautagebuecher').then(r => setLetzte(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  // Monteure sehen nur eigene Bautagebücher; Admin alle. /api/bautagebuecher liefert
  // serverseitig allen Berechtigten alle Datensätze — daher Filter im Frontend.
  const angezeigteBerichte = (isAdmin
    ? letzte
    : letzte.filter(b => b.user_id === user?.id)
  ).slice(0, 5);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Guten Tag, {user?.name?.split(' ')[0]} 👋</div>
          <div className="page-sub">{new Date().toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</div>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/bautagebuch/erstellen')}>+ Neues Bautagebuch</button>
      </div>

      {stats && (
        <div className="stat-grid">
          <div className="stat-card">
            <div className="stat-label">Aktive Baustellen</div>
            <div className="stat-value">{stats.aktive_baustellen}</div>
            <div className="stat-change">laufende Projekte</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">{isAdmin ? 'Stunden Diese Woche' : 'Deine Stunden'}</div>
            <div className="stat-value">{stats.stunden_woche?.toFixed(1) || '0'}</div>
            <div className="stat-change">{isAdmin ? 'alle Mitarbeiter' : 'diese Woche'}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">{isAdmin ? 'Berichte Heute' : 'Deine Berichte heute'}</div>
            <div className="stat-value">{stats.berichte_heute}</div>
            <div className="stat-change">{stats.berichte_woche} diese Woche</div>
          </div>
          {isAdmin && (
            <div className="stat-card" style={{ borderLeftColor: stats.material_warnung > 0 ? 'var(--red)' : 'var(--copper)' }}>
              <div className="stat-label">Material-Warnung</div>
              <div className="stat-value" style={{ color: stats.material_warnung > 0 ? 'var(--red)' : 'var(--text)' }}>{stats.material_warnung}</div>
              <div className="stat-change">Positionen nachbestellen</div>
            </div>
          )}
        </div>
      )}

      <div className="card">
        <div className="card-head">
          <div className="card-title">{isAdmin ? 'Letzte Bautagebücher' : 'Deine letzten Bautagebücher'}</div>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate('/bautagebuch')}>Alle ansehen →</button>
        </div>
        {angezeigteBerichte.length === 0 ? (
          <div className="empty">
            <div className="empty-icon">📋</div>
            <h3>Noch keine Berichte</h3>
            <p>Erstelle deinen ersten Bautagebuch-Eintrag.</p>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Datum</th><th>Baustelle</th><th>Bauleiter</th><th>Status</th></tr>
              </thead>
              <tbody>
                {angezeigteBerichte.map(b => (
                  <tr key={b.id} onClick={() => navigate(`/bautagebuch/${b.id}`)} style={{ cursor: 'pointer' }}>
                    <td className="text-mono">{b.datum ? new Date(b.datum).toLocaleDateString('de-DE') : '–'}</td>
                    <td style={{ fontWeight: 500 }}>{b.baustelle_name || '–'}</td>
                    <td>{b.bauleiter || '–'}</td>
                    <td>
                      {b.status === 'fertig'
                        ? <span className="badge badge-copper">Fertig</span>
                        : <span className="badge badge-amber">Entwurf</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
